export const api = {
	baseUrl: 'https://admin.shahrstory.ir/api/app/v1',
	getMarkers: '/home',
	search: (query) => `/search?needle=${query}`,
	getStoryDetail: (id) => `/stories/show/${id}`,
	// Auth
	register: '/auth/register',
	login: '/auth/login',
	logout: '/auth/logout',
	sendSms: '/auth/send-sms',
	mobileVerification: 'auth/mobile-verification',
	refreshToken: '/auth/refresh-token',
	forgetPassword: 'auth/forget-password',
	// Profile
	profile: '/user-panel/profile',
	updateProfile: '/user-panel/profile/update',
	changePassword: '/user-panel/profile/change-password',
	// Production
	productions: '/user-panel/productions',
	storeStory: '/user-panel/productions/store',
	updateStory: '/user-panel/productions/upadte', // prouction_id
	deleteStory: '/user-panel/productions/delete' // prouction_id
};